import { render, staticRenderFns } from "./charmRelationDocu.vue?vue&type=template&id=43af1af7"
import script from "./charmRelationDocu.vue?vue&type=script&lang=js"
export * from "./charmRelationDocu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43af1af7')) {
      api.createRecord('43af1af7', component.options)
    } else {
      api.reload('43af1af7', component.options)
    }
    module.hot.accept("./charmRelationDocu.vue?vue&type=template&id=43af1af7", function () {
      api.rerender('43af1af7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/plan/charmRelationDocu.vue"
export default component.exports